import firebase from "firebase";

let firebaseConfig = {
    apiKey: "AIzaSyBfmMc4-dRd1_y9rvNSoUTmIox815S3moA",
    authDomain: "chatapp-ea735.firebaseapp.com",
    projectId: "chatapp-ea735",
    storageBucket: "chatapp-ea735.appspot.com",
    messagingSenderId: "722247271255",
    appId: "1:722247271255:web:63e9d40119f729cc37b412"

}

export default firebase.initializeApp(firebaseConfig);

